<p-table
  [value]="ediciones"
  [paginator]="true"
  [rows]="5"
  [rowsPerPageOptions]="[5, 10, 20]"
  [tableStyle]="{ 'min-width': '50rem' }"
  [showCurrentPageReport]="true"
  paginatorDropdownAppendTo="body"
  currentPageReportTemplate="{first} - {last} de {totalRecords}"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Fecha</th>
      <th>Descripción</th>
      <th>Usuario</th>
      <th><p class="text-center">Acciones</p></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-edicion>
    <tr class="item">
      <td>{{ edicion.fecha | date : 'dd/MM/yyyy HH:mm' }}</td>
      <td>{{ edicion.descripcion }}</td>
      <td>
        {{
          edicion.usuario_editor
            ? edicion.usuario_editor.nombre +
              ' ' +
              edicion.usuario_editor.apellido
            : 'Sin información'
        }}
      </td>
      <td class="flex justify-center items-center">
        @if(properties && edicion.old_registro) {
        <div
          pTooltip="Ver registro anterior"
          class="rounded-full p-3 flex justify-center items-center bg-red-900 shadow-md text-white cursor-pointer"
          (click)="div.classList.toggle('show')"
        >
          <i class="pi pi-pen-to-square"></i>
        </div>
        } @else {
        <p>Ninguna</p>
        }
      </td>
    </tr>
    <tr>
      <td colspan="4">
        <div class="hide w-full" #div>
          <div>
            @if(edicion.parseObject){
            <div class="p-2 text-start">
              @for (item of properties; track $index) {
              <small>
                <b>{{ item.label }}:</b>
                {{ item.value(edicion.parseObject) }}
              </small>
              <br />
              }
            </div>
            }
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
